require('./kovVerticalTabs.scss');

const TYPES = ['extended', 'compact'];
const kovVerticalTabsOnClick = 'onClick';

class KovVerticalTabs {
  constructor($state, $scope) {
    'ngInject';
    this.$state = $state;
    this.$scope = $scope;
  }

  $onInit() {

    this.sType = this.sType && TYPES.find(t => t === this.sType) || 'extended';

    this.sTabs.forEach(tab => {
      tab.active = tab.active && !tab.disabled || false;
    });

    this.sTabs.forEach(tab => {
      tab.disabled = tab.disabled || false;
    });

    let activeTab = this.sTabs.find(tab => tab.state.includes('.') && this.$state.current.name.startsWith(tab.state) || tab.state === this.$state.current);
    this.setActiveTab(activeTab);
  }

  setActiveTab(activeTab) {
    let previousActiveTab = this.sTabs.find(tab => tab.active);
    if (activeTab && previousActiveTab) {
      previousActiveTab.active = false;
    }

    if (activeTab) {
      activeTab.active = true;
      this.$scope.$emit(kovVerticalTabsOnClick, activeTab);
    }
  }

  onClick(tab) {
    if (!tab.disabled) {
      this.setActiveTab(tab);
    }
  }
}

module.exports = {
  template: require('./kovVerticalTabs.html'),
  controllerAs: 'ctrl',
  controller: KovVerticalTabs,
  bindings: {
    sTabs: '<',
    sType: '@'
  }
};